import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import type { AsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { ThunkHttpClient } from '../utils/httpThunkClient'
import { stat } from 'fs'
import { popMessage } from '../../App'


// First, create the thunk
export const selectlistApiFunction = ThunkHttpClient.get('DynamicList/list', ({url}) =>  url)

export const selectListPostApiFunction = ThunkHttpClient.post('DynamicList/post/list', (data) => ({url:data.url, body: data.body}))




// Define the initial state using that type
const initialState: any = {
    citys : [{id: '1', name: 'Dubai'}, {id: '2', name: 'Abu Dhabi'}],
    country : [{id: '1', name: 'UAE'}, {id: '2', name: 'India'}],
    hotels : [{id: '1', name: 'Paramount'}, {id: '2', name: 'Nirvan Hotel'}],
    tours: [{id: '1', name: 'Burjkhalifa top view'}, {id: '2', name: 'The frame'}],
    supplier: [{id: '1', name: 'Supplier 1'}, {id: '2', name: 'Supplier 2'}],
    tickets: [{id: '1', name: 'Ticket 1'}, {id: '2', name: 'Ticket 2'}],
    teamgroups: [{id: '1', name: 'Group 1'}, {id: '2', name: 'Group 2'}],
    airlines: [{id: '1', name: 'Air India'}, {id: '2', name: 'Indigo'}],
    airport: [{id: '1', name: 'Jaipur'}, {id: '2', name: 'UAE'}],

}

export const SelectSlice = createSlice({
    name: 'selectdynamic',
    initialState,
    reducers: {
        
    },

    extraReducers: (builder) => {
       
        builder.addCase(selectlistApiFunction.fulfilled, (state, action) => {
            const component = action.meta.arg.componentuniquekey;
            state[component] = action.payload && action.payload.data
            state[`${component}loading`] = false; 
        })
        builder.addCase(selectlistApiFunction.pending, (state, action) => {
            const component = action.meta.arg.componentuniquekey;
            state[component] = state[component] || []
            state[`${component}loading`] = true;
        })
        builder.addCase(selectlistApiFunction.rejected, (state, action) => {
            const component = action.meta.arg.componentuniquekey;
            state[component] = state[component] || []
            state[`${component}loading`] = false;
        })

        builder.addCase(selectListPostApiFunction.fulfilled, (state, action) => {
            console.log(action.payload)
            const component = action.meta.arg.componentuniquekey;
            state[component] = state[component] || []
            state[`${component}loading`] = false;
          })
          builder.addCase(selectListPostApiFunction.pending, (state, action) => {
            const component = action.meta.arg.componentuniquekey;
            state[component] = state[component] || []
            state[`${component}loading`] = true;
          })
      
          builder.addCase(selectListPostApiFunction.rejected, (state, action) => {
            const component = action.meta.arg.componentuniquekey;
            state[component] = state[component] || []
            state[`${component}loading`] = false;
          })
    },
})

export default SelectSlice.reducer